import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { DefaultPageSize } from '@rma/generic/domain/types';

@Component({
  selector: 'rma-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SkeletonComponent {
  @Input()
  public bones: number = DefaultPageSize;

  @Input()
  @HostBinding('class')
  public template: 'single-block' | 'default' | 'avatar' = 'default';
}
